module.exports = __webpack_public_path__ + "img/11-22_728_x_90-ServicePortal.afb859a8.png";